/**
 * author: Ananthapadmanabhan V K
 */
import React from 'react';
import './Sign-up.scss';
import { withTranslation } from 'react-i18next';
import { Button, input } from 'react-bootstrap';

const Signup = ({ t }) => {

  return (

    <section className="Signin_page_section">
      <div className="row m-0">
        <div className="col-lg-6 col-md-6 p-0 Login_leftBox">
          <div className="Login_leftBox_Logo">
            <h1 className="m-0">SCM Cockpit</h1>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 p-0 Login_RightBox">
          <div className="Login_Form">
            <div className="Login_Form_in">
              <div className="mb-4 Login_Form_in_head">
                <h3>{t("signup.label")}</h3>
                <p>Welcome. Just a few steps to get started.</p>
              </div>
              <form>
                <div className="mb-4">
                  <div className="mb-3">
                    <label className="mb-1">{t("Emailid.label")}</label>
                    <input type="email" className="form-control" placeholder={t("EnterEmail.label")}
                      aria-describedby="emailHelp" />
                  </div>
                  <div className="mb-3">
                    <label for="exampleInputPassword1" className="mb-1">{t("password.label")}</label>
                    <input type="password" className="form-control" placeholder={t("EnterPassword.label")} />
                  </div>
                  <div className="mb-3">
                    <label for="exampleInputPassword1" className="mb-1">{t("ConfirmPassword.label")}</label>
                    <input type="password" className="form-control" placeholder={t("EnterConfirmPassword.label")} />
                  </div>
                  <div className="pb-2 form-check">
                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                    <label className="form-check-label" for="exampleCheck1">
                      {t("IAgree.label")} <a href="#">{t("termsServices.label")}</a> {t("and.label")}
                      <a href="#"> {t("privacyPolicy.label")}</a>
                    </label>
                  </div>
                </div>
                <button type="submit" className="btn btn-primary w-100 sbmBtn">{t("continue.label")}</button>
                <div className="py-2 mt-3 text-center">
                  <p>{t("alreadyAccount.label")} <a href="/login">{t("login.label")}</a></p>
                </div>
              </form>
            </div>

          </div>



        </div>
      </div>
    </section>

  );

};

export default withTranslation()(Signup);
